module.exports = {"513226101":"观音桥镇","513226102":"安宁镇","513226103":"勒乌镇","513226200":"沙耳乡","513226201":"庆宁乡","513226202":"咯尔乡","513226204":"万林乡","513226205":"河东乡","513226206":"河西乡","513226207":"集沐乡","513226208":"撒瓦脚乡","513226209":"卡拉足乡","513226210":"俄热乡","513226211":"太阳河乡","513226212":"二嘎里乡","513226213":"阿科里乡","513226215":"卡撒乡","513226216":"曾达乡","513226217":"独松乡","513226218":"马尔邦乡","513226219":"马奈乡","513226220":"毛日乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513226.json
// module id = 2218
// module chunks = 0